@if (isAnswered) {
  <div class="text-xs text-base-content/60 mt-1 ml-1">✓ {{ answer === 'yes' ? confirmLabel : 'Nein' }}</div>
} @else {
  <div class="flex flex-wrap gap-2 mt-2 ml-1">
    <button type="button" class="btn btn-sm btn-primary" (click)="choose('yes')">{{ confirmLabel }}</button>
    <button type="button" class="btn btn-sm btn-outline" (click)="choose('no')">Nein</button>
  </div>
}
